import { connect } from 'react-redux'
import PresenterBar from './PresenterBar'
import { State } from '../../dataStore/reducers/reducerType'
import selectLocalParticipant from '../../dataStore/selectors/selectLocalParticipant'
import { OBSERVER } from '../../dataStore/constants/roles'

const mapStateToProps = (state: State) => ({
  networkQuality: state.config.networkQuality,
  participant: selectLocalParticipant(state),
  isObserver: state.config.role === OBSERVER
})

export default connect(mapStateToProps)(PresenterBar)
